module.exports = __webpack_public_path__ + "img/renegades2.556a4e6.jpg";